module.exports = __webpack_public_path__ + "img/sign-72.35b4cba0.jpg";